module.exports = __webpack_public_path__ + "static/media/kurve.0f203eba.png";